<ng-container *ngIf="!!get && !!form" [formGroup]="form">
    <tt-input *ngIf="get.setting_show_oh_head_stat_cust_no !== '0'" ttLabel="orderhead_stat_cust_no" formControlName="stat_cust_no" ttReadonly>
        <ng-container buttons>
            <tt-form-field-button ttIcon="fas fa-plus" ttTooltip="goto_new_customer" [ttTranslateTooltip]="true" ttGoto="customeredit" [ttGotoParms]="{ cust_no: '0' }"></tt-form-field-button>
            <tt-form-field-button
                ttIcon="fas fa-pen"
                ttTooltip="goto_customeredit"
                [ttTranslateTooltip]="true"
                ttGoto="customeredit"
                [ttGotoParms]="{ cust_no: '' + form.controls.stat_cust_no.value }"
            ></tt-form-field-button>
            <tt-form-field-button
                ttIcon="fas fa-chevron-right"
                ttTooltip="goto_customersmenu"
                [ttTranslateTooltip]="true"
                ttGoto="customersmenu"
                [ttGotoParms]="{ cust_no: '' + form.controls.stat_cust_no.value }"
            ></tt-form-field-button>
        </ng-container>
    </tt-input>
    <tt-search
        *ngIf="get.setting_show_oh_head_stat_cust_name !== '0'"
        ttLabel="stat_cust_name"
        formControlName="stat_cust_name"
        [ttSearch]="searchCustomers"
        (ttOnSelected)="onCustomerSelected($event)"
        (ttOnClear)="onCustomerSelected()"
    ></tt-search>
    <tt-textarea *ngIf="get.setting_show_oh_head_stat_cust_address !== '0'" ttLabel="orderhead_stat_cust_address" formControlName="stat_cust_address" ttReadonly></tt-textarea>
    <tt-select *ngIf="get.setting_show_oh_head_contact_pers_no !== '0'" ttLabel="contact_person" formControlName="contact_pers_no" [ttData]="customerPersons" ttDataId="item_id" ttDataName="item_name">
        <ng-container buttons>
            <tt-form-field-button
                ttIcon="fas fa-chevron-right"
                ttTooltip="goto_contactpersons"
                [ttTranslateTooltip]="true"
                ttGoto="customerpersons"
                [ttGotoParms]="{ cust_no: form.controls.stat_cust_no.value }"
            ></tt-form-field-button>
        </ng-container>
    </tt-select>
    <tt-input *ngIf="get.setting_show_oh_head_customers_orderno !== '0'" ttLabel="customers_orderno" formControlName="customers_orderno"></tt-input>
    <tt-input *ngIf="get.show_svea_prepayment === '1'" ttLabel="svea_payment_uri" formControlName="svea_payment_uri" ttReadonly></tt-input>
    <ng-container *ngIf="get.setting_show_oh_head_project_name !== '0'">
        <tt-input ttLabel="project_keyno" formControlName="project_keyno" ttReadonly>
            <ng-container buttons>
                <tt-form-field-button
                    *ngIf="+form.controls.project_keyno.value === 0"
                    ttIcon="fas fa-plus"
                    ttTooltip="goto_orderheadcreateproject"
                    [ttTranslateTooltip]="true"
                    ttGoto="orderheadcreateproject"
                    [ttGotoParms]="{ order_internal_no: '' + get.order_internal_no }"
                ></tt-form-field-button>
                <tt-form-field-button
                    *ngIf="+form.controls.project_keyno.value > 0"
                    ttIcon="fas fa-chevron-right"
                    ttTooltip="goto_projectmenu"
                    [ttTranslateTooltip]="true"
                    ttGoto="projectmenu"
                    [ttGotoParms]="{ project_keyno: '' + form.controls.project_keyno.value }"
                ></tt-form-field-button>
            </ng-container>
        </tt-input>
        <tt-search
            ttLabel="project_name"
            ttMinLength="0"
            formControlName="project_name"
            [ttSearch]="searchProjects"
            (ttOnSelected)="onProjectSelected($event)"
            (ttOnClear)="onProjectSelected()"
        ></tt-search>
    </ng-container>

    <tt-search
        *ngIf="get.show_serviceobject_keyno === '1'"
        ttLabel="serviceobject_name"
        formControlName="serviceobject_name"
        [ttSearch]="searchServiceObjects"
        (ttOnSelected)="onServiceObjectSelected($event)"
        (ttOnClear)="onServiceObjectSelected()"
    >
        <ng-container *ngIf="+form.controls.serviceobject_keyno.value > 0" buttons>
            <tt-form-field-button
                ttIcon="fas fa-chevron-right"
                ttTooltip="goto_serviceobject"
                [ttTranslateTooltip]="true"
                ttGoto="serviceobjectmenu"
                [ttGotoParms]="{ serviceobject_keyno: form.controls.serviceobject_keyno.value }"
            ></tt-form-field-button>
        </ng-container>
    </tt-search>
    <tt-input *ngIf="get.setting_show_oh_head_customers_ref1 !== '0'" ttLabel="customers_ref1" formControlName="customers_ref1"></tt-input>
    <tt-input *ngIf="get.setting_show_oh_head_customers_ref2 !== '0'" ttLabel="customers_ref2" formControlName="customers_ref2"></tt-input>
    <tt-textarea *ngIf="get.setting_show_oh_head_message_from_sales !== '0'" ttLabel="message_from_sales" formControlName="message_from_sales"></tt-textarea>
    <tt-textarea *ngIf="get.setting_show_oh_head_message_to_supplier !== '0'" ttLabel="message_to_supplier" formControlName="message_to_supplier"></tt-textarea>
    <tt-input *ngIf="get.setting_show_oh_head_label !== '0'" ttLabel="label" formControlName="label"></tt-input>
    <tt-select *ngIf="get.setting_show_oh_head_stat_business_id !== '0'" ttLabel="business" formControlName="stat_business_id" [ttData]="businesses" ttDataId="business_id" ttDataName="business_name">
        <ng-container buttons>
            <tt-form-field-button ttIcon="fas fa-chevron-right" ttTooltip="goto_businesss" [ttTranslateTooltip]="true" ttGoto="businesss"></tt-form-field-button>
        </ng-container>
    </tt-select>

    <tt-select *ngIf="get.show_oh_head_stat_coop_id === '1'" ttLabel="coop" formControlName="stat_coop_id" [ttData]="coops" ttDataId="coop_id" ttDataName="coop_name"></tt-select>
</ng-container>
